import React from "react";
import styled from "styled-components";
import { Container, Row, Col } from "react-bootstrap";

import { Title, Section, Box, Text } from "../../components/Core";

import yonas from "../../assets/image/jpeg/yonas-fshot-kesto.jpeg";
import tesh from "../../assets/image/jpeg/tesh-fshot-kesto.jpg";
import tedla from "../../assets/image/jpeg/tedla-fshot-kesto.jpeg";
import simon from "../../assets/image/jpeg/simon-fshot-kesto.jpg";


import jimmy from "../../assets/image/jpeg/jimmy.jpeg";
import kiara from "../../assets/image/jpeg/kiara.png";


const CardImage = styled.div`
  max-width: 160px;
  min-width: 160px;
  min-height: 160px;
  max-height: 250px;
  overflow: hidden;
  border-radius: 20px;
  display: inline-flex;
  align-items: center;
  margin-bottom: 29px;
`;

const TeamCard = ({ userImg, title, children, ...rest }) => (
  <Box
    className="text-center"
    pt="15px"
    px="30px"
    borderRadius={10}
    mb={4}
    {...rest}
  >
    <CardImage>
      <img src={userImg} className="img-fluid" alt="" />
    </CardImage>
    <div className="text-center">
      <Title variant="card" fontSize="24px" letterSpacing={-0.75} my={1}>
        {title}
      </Title>
      <Text fontSize={2} lineHeight={1.75}>
        {children}
      </Text>
    </div>
  </Box>
);

const Team = () => (
  <>
    {/* <!-- Team section --> */}
    <Section className="position-relative pt-1">
      <Container>
        <Row className="justify-content-center">
          <Col lg="6" className="text-center pb-3">
            <div className="">
              <Title>Meet the team</Title>
            </div>
          </Col>
        </Row>
        <Row className="align-items-center justify-content-center">
          {/* <Col sm="6" md="5" lg="4" className="mt-3 mt-lg-4">
            <TeamCard userImg={tesh} title="Teshager">
              Product and Technology
            </TeamCard>
          </Col> */}

          <Col sm="6" md="5" lg="4" className="mt-3 mt-lg-4">
            <TeamCard userImg={yonas} title="Yonas">
              Data
            </TeamCard>
          </Col>
          <Col sm="6" md="5" lg="4" className="mt-3 mt-lg-4">
            <TeamCard userImg={simon} title="Simon">
              Sales
            </TeamCard>
          </Col>
          <Col sm="6" md="5" lg="4" className="mt-3 mt-lg-4">
            <TeamCard userImg={tedla} title="Tedla">
              Bizdev & Marketing
            </TeamCard>
          </Col>

        </Row>
      </Container>
    </Section>
  </>
);

export default Team;
